import React, { useState, useEffect } from 'react';
import http from "../http-common";
import { CircularProgress, Typography, Box } from '@mui/material';
import ModernButton from './ModernButton';  // Adjust import based on your project structure

const RunHarmonizationButton = () => {
  const [timer, setTimer] = useState(0);  // Timer state in seconds
  const [jobResult, setJobResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleRunJob = async () => {
    try {

    // Clear previous messages immediately
      setJobResult(null);
      setErrorMessage(null);

    // Start the API request

      const response = await http.get('/StoredProcedureLogProcComparison');

      // Set the result and start the 5-minute timer

      setJobResult(response.data);
    //   setErrorMessage(null);
      setTimer(100);  // Start 5-minute timer (300 seconds)
    } catch (error) {
        // Clear previous messages
      setJobResult(null);

      // Set error message and start the timer
      const apiErrorMessage = error.response?.data?.message || 'An error occurred.';
      setErrorMessage(`Error: ${apiErrorMessage}`);
      setTimer(100);  // Optional: Only set timer if the job was initiated
    }
  };

  // Timer countdown logic
  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);  // Decrease by 1 second
    } else if (timer === 0) {
      clearInterval(interval);
    }
    if (timer === 0) {
        setJobResult(null);
        setErrorMessage(null);
        clearInterval(interval);
      }
    return () => clearInterval(interval);  // Cleanup on unmount
  }, [timer]);

  return (
    <>
    
    <Box textAlign="center">
      <ModernButton onClick={handleRunJob} disabled={timer > 0}>
        {timer > 0 ? "Please wait..." : "Harmonize Data"}
      </ModernButton>

      {/* Circular Timer Display */}
      {timer > 0 && (
        <Box mt={2} position="relative" display="inline-flex">
          <CircularProgress variant="determinate" value={((300 - timer) / 300) * 100} size={80} thickness={4} />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            // position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="caption" component="div" color="textSecondary">
              {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, '0')}
            </Typography>
          </Box>
        </Box>
      )}

      {/* Display job result or error */}
      {jobResult && <Typography color="green">{jobResult.message}</Typography>}
      {errorMessage && <Typography color="red">{errorMessage}</Typography>}
    </Box>
    </>
  );
};

export default RunHarmonizationButton;
